// Редирект с "/" на первый доступный tool (PRD §3.1).
// Если у юзера нет ни одного tool'а — рендерим заглушку.
import { Navigate } from "react-router-dom";
import { Result } from "antd";
import { useMe } from "@/hooks/useAuth";

export function HomeRedirect() {
  const { data: me } = useMe();
  if (!me) return null; // ProtectedRoute уже разруливает unauthenticated

  const firstTool = me.tools.find((t) => t.category !== "admin");
  if (firstTool) {
    return <Navigate to={`/tools/${firstTool.slug}`} replace />;
  }

  if (me.is_superuser) {
    return <Navigate to="/admin/users" replace />;
  }

  return (
    <Result
      status="info"
      title="Нет доступных инструментов"
      subTitle="Обратитесь к администратору, чтобы получить доступ к инструментам."
    />
  );
}
